import { useSelectedLocationGeoEventId } from 'features/locations/hooks/useSelectedLocationGeoEventId';
import { useSelectedIncidentGeoEventId } from 'features/geoEvents/hooks/useSelectedIncidentGeoEventId';

export const useSelectedGeoEventId = (): number | undefined => {
  const selectedGeoEventId = useSelectedIncidentGeoEventId();
  const selectedLocationId = useSelectedLocationGeoEventId();

  return selectedGeoEventId || selectedLocationId;
};
